/**
 * Parses a page number from a string parameter with validation.
 * Returns 1 as default for invalid or missing values.
 * @param pageParam - The page parameter string to parse
 * @returns A valid page number (integer > 0) or 1 as default
 */
export function parsePageNumber(pageParam: string | null): number {
  if (!pageParam) {
    return 1
  }
  const parsedPage = Number(pageParam)
  const isValidPageParam = Number.isInteger(parsedPage) && parsedPage > 0
  return isValidPageParam ? parsedPage : 1
}
